import '@/assets/styles/global/index.scss';
import GhMarquee from '@/components/base/GhMarquee.vue';
import GhMenu from '@/components/base/GhMenu.vue';
import GhModal from '@/components/base/GhModal.vue';
import GhSidebar from '@/components/base/GhSidebar.vue';
import GhTooltip from '@/components/base/GhTooltip.vue';
import ListItem from '@/components/base/ListItem.vue';
import SvgIcon from '@/components/base/SvgIcon.vue';
import TourTooltip from '@/components/base/TourTooltip.vue';
import VerticalTextLink from '@/components/base/VerticalTextLink.vue';
import ErrorMsgService from '@/components/layout/ErrorMsgService.vue';
import HeaderSearchBox from '@/components/layout/HeaderSearchBox.vue';
import LayoutFooter from '@/components/layout/LayoutFooter.vue';
import PlaygroundLayout from '@/components/layout/PlaygroundLayout.vue';
import PrintService from '@/components/print/PrintService.vue';
import { installSharedRuntimeBridges, mountVuePage } from '@/main';
import { registerRuntimeComponents } from '@/runtime/components/register-components.runtime';
import { installPortfolioShareRuntime } from '@/runtime/portfolio/install-portfolio-share.runtime';

let isInstalled = false;

/**
 * 安裝 _LayoutIndex 共用 runtime
 */
const installLayoutIndexRuntime = (): void => {
    if (isInstalled) return;

    installSharedRuntimeBridges();
    registerRuntimeComponents({
        'gh-marquee': GhMarquee,
        'gh-menu': GhMenu,
        'gh-modal': GhModal,
        'gh-sidebar': GhSidebar,
        'gh-tooltip': GhTooltip,
        'list-item': ListItem,
        'svg-icon': SvgIcon,
        'tour-tooltip': TourTooltip,
        'vertical-text-link': VerticalTextLink,
        'error-msg-service': ErrorMsgService,
        'header-search-box': HeaderSearchBox,
        'playground-layout': PlaygroundLayout,
        'print-service': PrintService,
    });

    isInstalled = true;
};

installLayoutIndexRuntime();

installPortfolioShareRuntime();

mountVuePage({
    selector: '#layoutIndexFooterApp',
    appKey: 'shared-_layout-index-footer',
    render: (h) => h(LayoutFooter),
});
